import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import "./index.css";
import "./translation/i18n.js";
import { initVersionCheck } from "./services/versionCheck.js";

// Cache beim App-Start immer leeren (aber nicht Cookie-Consent!)
try {
  // Speichere CCM19 Cookie-Consent temporär
  const ccmConsent = localStorage.getItem('CCM19');
  
  localStorage.clear();
  sessionStorage.clear();
  
  // Stelle CCM19 Cookie-Consent wieder her
  if (ccmConsent) {
    localStorage.setItem('CCM19', ccmConsent);
  }
  
  // Alle Browser-Caches leeren
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    });
  }
} catch (e) {
  console.error("[main] Failed to clear storage:", e);
}

// Starte Versions-Check beim App-Start
initVersionCheck();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
